<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import { required } from '@validations';

extend('query_name', {
  validate: (value) => /^[a-zA-Z]+$/.test(value),
  message: 'O campo {_field_} deve conter apenas letras, sem espaços ou números',
});

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        regraid: '',
        nome_regra: '',
        versao_regra: '1.0',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  data() {
    return {
      dataFromApiRegratipo: [
        { tipo_regra: 'SELECT', regratipodescricao: 'SELECT' },
        { tipo_regra: 'CREATE', regratipodescricao: 'CREATE' },
        { tipo_regra: 'UPDATE', regratipodescricao: 'UPDATE' },
        { tipo_regra: 'DELETE', regratipodescricao: 'DELETE' },
        { tipo_regra: 'INSERT', regratipodescricao: 'INSERT' },
      ],
      isFormValid: false,
    };
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isButtonDisabled() {
      return (
        this.dataForm.isDefault
        || !this.dataForm.nome_regra
        || !this.dataForm.descricao_regra
        || !this.dataForm.tipo_regra
        || !this.dataForm.comando
        || !this.isFormValid
      );
    },
  },
  watch: {
    dataForm: {
      handler() {
        this.validateFormFields();
      },
      deep: true,
    },
  },
  methods: {
    async validateFormFields() {
      if (this.$refs.refFormData) {
        const isValid = await this.$refs.refFormData.validate();
        this.isFormValid = isValid;
      }
    },
    async validateForm() {
      const isValid = await this.$refs.refFormData.validate();

      if (!isValid) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Formulário inválido',
            text: 'Corrija os erros de validação antes de continuar.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      if (!this.dataForm.nome_regra || !this.dataForm.descricao_regra || !this.dataForm.tipo_regra || !this.dataForm.comando) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Formulário incompleto',
            text: 'Preencha todos os campos obrigatórios.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      this.dataForm.versao_regra = '1.0';
      this.$emit('ok', this.dataForm);
      this.$bvModal.hide(this.idModal);
    },
  },
  mounted() {
    this.validateFormFields();
  },
};
</script>

<template>
  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      :id="idModal"
      :title="titleModal"
      :ok-disabled="isButtonDisabled"
      :ok-title="labelBtnOk"
      ok-variant="success"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      @ok="validateForm"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
  >
    <validation-observer ref="refFormData" v-slot="{ invalid }">
      <b-form @submit.prevent>
        <b-row>
          <b-col
              cols="4"
              class="mb-1"
          >
            <b-form-group
                label="Nome da Regra"
                label-for="nome_regra"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Nome da Regra"
                  rules="required|query_name"
                  @input="validateFormFields"
              >
                <b-form-input
                    v-model="dataForm.nome_regra"
                    id="nome_regra"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite o nome"
                    @input="validateFormFields"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="4"
              class="mb-1"
          >
            <b-form-group
                label="Descrição"
                label-for="descricao_regra"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.descricao_regra"
                    type="text"
                    id="descricao_regra"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a Descrição"
                    @input="validateFormFields"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="4"
              class="mb-1"
          >
            <b-form-group
                label="Tipo Regra"
                label-for="tipo_regra"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Tipo Regra"
                  rules="required"
              >
                <b-form-select
                    v-model="dataForm.tipo_regra"
                    id="tipo_regra"
                    :state="errors.length > 0 ? false : null"
                    :options="dataFromApiRegratipo"
                    value-field="tipo_regra"
                    text-field="regratipodescricao"
                    placeholder="Selecione uma utilização"
                    @change="validateFormFields"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Comando (query)"
                label-for="comando"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Comando"
                  rules="required"
              >
                <b-form-textarea
                    v-model="dataForm.comando"
                    id="comando"
                    :state="errors.length > 0 ? false:null"
                    rows="10"
                    placeholder="Digite o comando"
                    @input="validateFormFields"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
